import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'react-bootstrap';

const FilterCheckboxComponent = ({
  filters,
  currentFilters,
  onFilterChange
}) => (
  <div style={{ textAlign: 'right' }}>
    <div style={{ display: 'inline-block', paddingRight: '10px' }}>Show:</div>
    {
      filters.map((f, i) => (
        <Checkbox
          key={i}
          onChange={c => onFilterChange(f, !c.target.checked)}
          checked={!currentFilters[f]}
          inline
        >
          {f}
        </Checkbox>
      ))
    }
  </div>
);

FilterCheckboxComponent.propTypes = {
  filters: PropTypes.arrayOf(PropTypes.string).isRequired,
  currentFilters: PropTypes.object.isRequired,
  onFilterChange: PropTypes.func.isRequired
};

export default FilterCheckboxComponent;


// WEBPACK FOOTER //
// src/Components/FilterCheckboxComponent.jsx